(() => {
  const root = document.querySelector('.jsl');
  if (!root) return;
  const $$ = (s, r = root) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- behaviour (works without GSAP) ---------- */

  // sticky CTA after the hero leaves, hidden while the order block is visible
  const sticky = root.querySelector('.jsl-sticky');
  const hero = root.querySelector('.jsl-hero');
  const order = root.querySelector('#jsl-order');
  if (sticky && hero && 'IntersectionObserver' in window) {
    let pastHero = false, atOrder = false;
    const phone = matchMedia('(max-width: 989px)');
    const upd = () => sticky.classList.toggle('is-on', (phone.matches || pastHero) && !atOrder);
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; upd(); }).observe(hero);
    if (order) new IntersectionObserver(([e]) => { atOrder = e.isIntersecting; upd(); }, {threshold: 0.15}).observe(order);
  }

  // EasySell COD form -> Excelsior Auto order sheet. EasySell re-writes inline !important styles and copy, so they are re-applied on every re-render.
  const ES_TXT = {
    head: 'عمّر المعلومات ديالك',
    sub: 'ما كتخلّص والو دابا، الدفع حتى يوصلك الجهاز.',
    fields: {
      first_name: ['الاسم الكامل', 'مثلا: محمد العلوي'],
      city: ['المدينة', 'مثلا: الدار البيضاء'],
      address: ['العنوان', 'الحي، الزنقة، الرقم'],
      phone: ['رقم التيليفون', '06 XX XX XX XX'],
    },
    slip: {price: 'الثمن', ship: 'التوصيل', shipV: 'فابور', gift: 'الهدية', giftV: 'مع الطلب', total: 'المجموع عند الاستلام', cur: 'درهم'},
    cta: 'أكّد الطلب',
    note: 'غادي نتاصلو بيك باش نأكدو الطلب',
  };
  const ES_BTN = {
    'background': '#1F6BFF', 'background-color': '#1F6BFF', 'color': '#ffffff', 'border-radius': '16px', 'border-width': '0px',
    'font-size': '19px', 'font-weight': '800', 'box-shadow': '0 12px 28px -12px rgba(31,107,255,.75), inset 0 1px 0 rgba(255,255,255,.16)',
  };
  const ES_BOX = {
    'background': '#0A1630', 'color': '#E8F3FF', 'border-color': 'rgba(142,163,199,.18)', 'border-style': 'solid',
    'border-width': 'var(--jsl-es-bw, 1px)', 'border-radius': 'var(--jsl-es-r, 20px)',
  };
  const setText = (el, t) => { if (el && el.textContent.trim() !== t) el.textContent = t; };
  const fmt = (n) => String(Math.round(n));
  const brandES = () => {
    const box = document.querySelector('#easysell #es-form-container');
    if (!box) return;
    if (box.style.getPropertyValue('border-radius') !== ES_BOX['border-radius']) for (const [p, v] of Object.entries(ES_BOX)) box.style.setProperty(p, v, 'important');
    // copy: "dh" prices -> درهم, English validation -> Darija
    const tw = document.createTreeWalker(box, NodeFilter.SHOW_TEXT);
    for (let n = tw.nextNode(); n; n = tw.nextNode()) {
      const v = n.nodeValue;
      if (/\d\s*dh\b/i.test(v)) n.nodeValue = v.replace(/(\d[\d,]*)(?:\.00)?\s*dh\b/gi, '$1 درهم');
      else if (/field is required/i.test(v)) n.nodeValue = 'هاد الخانة ضرورية';
      else if (/(valid|invalid|correct).*(phone|number)|(phone|number).*(valid|invalid|correct)/i.test(v)) n.nodeValue = 'دخل رقم تيليفون صحيح، مثلا 0612345678';
    }
    // header
    const strong = box.querySelector('.es-form-header strong');
    setText(strong, ES_TXT.head);
    if (strong && !strong.parentElement.querySelector('.jsl-es-sub')) {
      const s = document.createElement('div'); s.className = 'jsl-es-sub'; s.textContent = ES_TXT.sub; strong.insertAdjacentElement('afterend', s);
    }
    // delivery slip under the product line (price read from EasySell so it always matches the cart)
    const cart = box.querySelector('.es-cart_content-group');
    if (cart) {
      const priceTxt = (box.querySelector('.es-p-price') || {}).textContent || '';
      const m = priceTxt.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
      const price = m ? fmt(parseFloat(m[1])) : (root.querySelector('[data-price]')?.dataset.price || '350');
      let slip = cart.querySelector('.jsl-es-slip');
      if (!slip || slip.dataset.price !== price) {
        const S = ES_TXT.slip;
        slip?.remove(); slip = document.createElement('div'); slip.className = 'jsl-es-slip'; slip.dataset.price = price;
        const ck = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
        slip.innerHTML = `<div class="is-perks"><span>${ck}${S.ship} ${S.shipV}</span><span>${ck}${S.gift} ${S.giftV}</span></div>`
          + `<div class="is-total"><span>${S.total}</span><span><b>${price}</b><small>${S.cur}</small></span></div>`;
        cart.appendChild(slip);
      }
    }
    // fields
    for (const [k, [label, ph]] of Object.entries(ES_TXT.fields)) {
      const lab = box.querySelector(`.es-${k}-group .es-label`);
      const node = lab && [...lab.childNodes].find((n) => n.nodeType === 3 && n.textContent.trim());
      if (node && node.textContent.trim() !== label) node.textContent = label;
      const inp = box.querySelector(`#es-${k}`);
      if (!inp) continue;
      if (inp.placeholder !== ph) inp.placeholder = ph;
      const ac = {first_name: 'name', city: 'address-level2', address: 'street-address', phone: 'tel'}[k];
      if (inp.getAttribute('autocomplete') !== ac) inp.setAttribute('autocomplete', ac);
    }
    // the action
    const btn = box.querySelector('#es-form-button');
    if (btn) {
      if (btn.style.getPropertyValue('border-radius') !== ES_BTN['border-radius']) for (const [p, v] of Object.entries(ES_BTN)) btn.style.setProperty(p, v, 'important');
      const sub = btn.querySelector('.es-button-subtitle');
      const main = sub ? sub.parentElement.querySelector(':scope > span') : null;
      const price = box.querySelector('.jsl-es-slip')?.dataset.price || '350';
      setText(main, ES_TXT.cta); setText(sub, `${price} ${ES_TXT.slip.cur} عند الاستلام`);
      box.querySelector('.jsl-es-trust')?.remove();
      if (!box.querySelector('.jsl-es-note')) {
        const t = document.createElement('div'); t.className = 'jsl-es-note';
        t.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6.6 3.5c.5-.5 1.3-.5 1.8 0l2.2 2.2c.5.5.5 1.3 0 1.8l-1.3 1.3c.9 1.9 2.4 3.4 4.3 4.3l1.3-1.3c.5-.5 1.3-.5 1.8 0l2.2 2.2c.5.5.5 1.3 0 1.8l-1.2 1.2c-.9.9-2.2 1.2-3.4.8-4.6-1.5-8.2-5.1-9.7-9.7-.4-1.2-.1-2.5.8-3.4z"/></svg><span>${ES_TXT.note}</span>`;
        btn.insertAdjacentElement('afterend', t);
      }
    }
  };
  let esQueued = false, esWatched = null;
  const queueES = () => {
    if (esQueued) return; esQueued = true;
    requestAnimationFrame(() => {
      esQueued = false; brandES();
      const box = document.querySelector('#easysell #es-form-container');
      if (box && box !== esWatched) { // watch only the form for EasySell re-renders / inline style resets
        esWatched = box;
        new MutationObserver(queueES).observe(box, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'placeholder']});
      }
    });
  };
  new MutationObserver(queueES).observe(document.body, {childList: true});
  addEventListener('click', () => setTimeout(queueES, 60), true);
  queueES();

  // WhatsApp clicks: report as a Meta "Contact" event when the pixel is present
  $$('[data-wa]').forEach((a) => a.addEventListener('click', () => {
    try { window.fbq && window.fbq('track', 'Contact', {content_name: 'whatsapp_' + a.dataset.wa}); } catch (e) {}
    try { window.ttq && window.ttq.track('Contact', {content_name: 'whatsapp_' + a.dataset.wa}); } catch (e) {}
  }));
  // TikTok AddToCart (opening the EasySell form adds the product to the cart) + AddPaymentInfo (first keystroke in the form), once each
  const ttItem = () => {
    const root = document.querySelector('.jsl'); const price = Number((root && root.dataset.price) || 350);
    return {contents: [{content_id: (root && root.dataset.pid) || 'jump-starter-4-in-1', content_type: 'product', content_name: 'jump starter 4 in 1', price, quantity: 1}], value: price, currency: 'MAD'};
  };
  const ttOnce = {};
  const ttFire = (ev) => { if (ttOnce[ev]) return; ttOnce[ev] = 1; try { window.ttq && window.ttq.track(ev, ttItem()); } catch (e) {} };
  addEventListener('click', (e) => { if (e.target.closest && e.target.closest('#es-popup-button')) ttFire('AddToCart'); }, true);
  const _esClick = HTMLElement.prototype.click; // landing CTAs call #es-popup-button.click() programmatically
  HTMLElement.prototype.click = function () { if (this.id === 'es-popup-button') ttFire('AddToCart'); return _esClick.apply(this, arguments); };
  addEventListener('input', (e) => { if (e.target.closest && e.target.closest('#easysell-modal')) ttFire('AddPaymentInfo'); }, true);
  // TikTok ViewContent (EasySell only sends InitiateCheckout + Purchase to TikTok)
  try {
    const root = document.querySelector('.jsl');
    const price = Number((root && root.dataset.price) || 350);
    window.ttq && window.ttq.track('ViewContent', {contents: [{content_id: (root && root.dataset.pid) || 'jump-starter-4-in-1', content_type: 'product', content_name: 'jump starter 4 in 1', price}], value: price, currency: 'MAD'});
  } catch (e) {}

  // hero video: only the one matching the viewport, after first paint
  const startHero = () => $$('video[data-hero]').forEach((v) => {
    if (!v.dataset.src || !matchMedia(v.dataset.hero).matches || v.getAttribute('src')) return;
    v.src = v.dataset.src; v.play().catch(() => {});
  });
  if (document.readyState === 'complete') startHero(); else addEventListener('load', startHero, {once: true});
  matchMedia('(min-width: 990px)').addEventListener?.('change', startHero);

  // lazy videos: load when near, play only while visible (saves data + battery)
  const vids = $$('video[data-lazy], video[data-demo]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach(({target: v, isIntersecting}) => {
      if (isIntersecting) {
        v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); v.load(); });
        if (!reduce || !v.muted) v.play().catch(() => {});
      } else if (!v.paused) v.pause();
    }), {rootMargin: '150px 0px', threshold: 0.35});
    vids.forEach((v) => io.observe(v));
  }

  // sound toggles: only one video speaks at a time
  $$('.jsl-sound').forEach((btn) => {
    const v = btn.parentElement.querySelector('video');
    if (!v) return;
    btn.addEventListener('click', () => {
      const turnOn = v.muted;
      $$('video').forEach((o) => { if (o !== v && !o.muted) { o.muted = true; const b = o.parentElement.querySelector('.jsl-sound span'); if (b) b.textContent = b.parentElement.dataset.on; } });
      v.muted = !turnOn;
      if (turnOn) { v.currentTime = 0; v.play().catch(() => {}); }
      btn.querySelector('span').textContent = turnOn ? btn.dataset.off : btn.dataset.on;
      btn.setAttribute('aria-pressed', String(turnOn));
    });
  });

  // EasySell (popup mode) attaches its "order" trigger inside our product form. When it exists:
  // hide our add-to-cart fallback so every order goes through the COD form.
  const esBtn = () => document.querySelector('#es-popup-button, .es-popup-button');
  const syncEasySell = () => { if (esBtn()) { root.classList.add('has-es'); return true; } return false; };
  // the app loads on its own schedule: poll briefly instead of racing it
  if (!syncEasySell()) { let n = 0; const t = setInterval(() => { if (syncEasySell() || ++n > 60) clearInterval(t); }, 250); }

  // CTA -> COD form. With EasySell's popup trigger present, open it (it is a popup opener, not a submit).
  // Otherwise bring the form into view and focus its first field.
  root.addEventListener('click', (ev) => {
    const a = ev.target.closest('[data-cta], #jsl-form button[name="add"]');
    if (!a) return;
    const es = esBtn();
    if (es) { ev.preventDefault(); es.click(); return; }
    const target = root.querySelector('#jsl-form') || order;
    if (!target) return;
    ev.preventDefault();
    target.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'center'});
    setTimeout(() => { const f = target.querySelector('input:not([type=hidden]),select,textarea'); if (f) f.focus({preventScroll: true}); }, 750);
  });

  /* ---------- motion (GSAP + ScrollTrigger) ---------- */
  const start = () => {
    const g = window.gsap, ST = window.ScrollTrigger;
    if (!g || !ST || /[?&]nomotion\b/.test(location.search)) return; // page stays complete without motion
    g.registerPlugin(ST);
    root.classList.add('jsl-motion');
    const R = 1; // RTL: "from the start side" travels from +x

    // scroll progress (all motion prefs: it is state, not movement)
    g.to('[data-progress]', {scaleX: 1, ease: 'none', scrollTrigger: {start: 0, end: 'max', scrub: 0.3}});

    // remaining simple reveals
    const rIO = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); rIO.unobserve(e.target); } }), {rootMargin: '0px 0px -8% 0px'});
    $$('[data-r]').forEach((el) => rIO.observe(el));

    // gauge: reduced motion shows the end state, motion counts it up
    const gaugeSec = root.querySelector('[data-gauge-sec]');
    const ring = root.querySelector('[data-gauge-ring]');
    const num = root.querySelector('[data-gauge-num]');
    const CIRC = 578, TARGET = 0.7;

    const mm = g.matchMedia();
    mm.add({motion: '(prefers-reduced-motion: no-preference)', desktop: '(min-width: 990px)', hover: '(hover: hover)'}, (ctx) => {
      const {motion, desktop, hover} = ctx.conditions;
      if (!motion) { $$('[data-step]').forEach((li) => li.classList.add('is-on')); return; }

      /* 1. hero: the product "powers on", then the words arrive (split by word: Arabic letters must stay joined) */
      const h1 = root.querySelector('[data-split]');
      if (h1) {
        const walk = (n) => [...n.childNodes].forEach((c) => {
          if (c.nodeType === 3) {
            const f = document.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach((p) => { if (!p) return; if (/^\s+$/.test(p)) f.append(p); else { const s = document.createElement('span'); s.className = 'w'; s.textContent = p; f.append(s); } });
            c.replaceWith(f);
          } else if (c.nodeType === 1) walk(c);
        });
        walk(h1);
      }
      const media = root.querySelectorAll('.jsl-hero__media video, .jsl-hero__media img');
      g.timeline({defaults: {ease: 'expo.out'}})
        .fromTo(media, {scale: 1.14, filter: 'brightness(.35) saturate(.6)'}, {scale: 1, filter: 'brightness(1) saturate(1)', duration: 1.8}, 0)
        .from('[data-split] .w', {yPercent: 60, opacity: 0, filter: 'blur(8px)', duration: 0.9, stagger: 0.05}, 0.25)
        .from('.jsl-hero__sub, .jsl-hero .jsl-offer, .jsl-hero .jsl-btn, .jsl-hero .jsl-micro', {y: 18, opacity: 0, duration: 0.8, stagger: 0.07, clearProps: 'transform,opacity'}, 0.55);
      // hero depth on scroll
      // depth on scroll only on desktop, where copy sits over the media; on mobile the copy is below it and must stay solid
      if (desktop) {
        g.to(media, {yPercent: 10, ease: 'none', scrollTrigger: {trigger: hero, start: 'top top', end: 'bottom top', scrub: true}});
        g.to('.jsl-hero__inner', {yPercent: -6, opacity: 0.35, ease: 'none', scrollTrigger: {trigger: hero, start: 'center top+=25%', end: 'bottom top', scrub: true}});
      }

      /* 2. headings: clip reveal, not one more fade-up */
      $$('.jsl-h2').forEach((h) => g.from(h, {clipPath: 'inset(0 0 100% 0)', y: 20, duration: 1, ease: 'expo.out', scrollTrigger: {trigger: h, start: 'top 88%', once: true}}));

      /* 3. feature cards as a list + image depth */
      g.set('[data-card]', {opacity: 0, y: 34, x: 14 * R});
      ST.batch('[data-card]', {start: 'top 88%', once: true, onEnter: (els) => g.to(els, {opacity: 1, y: 0, x: 0, duration: 0.9, ease: 'expo.out', stagger: 0.08, overwrite: true})});
      $$('[data-parallax]').forEach((img) => g.fromTo(img, {yPercent: -5}, {yPercent: 5, ease: 'none', scrollTrigger: {trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: true}}));

      /* 4. SIGNATURE: the gauge inflates to 2.50 bar and stops by itself, exactly like the device */
      if (gaugeSec && ring && num) {
        const o = {v: 0};
        g.set(ring, {strokeDashoffset: CIRC});
        num.textContent = '0.00';
        g.timeline({scrollTrigger: {trigger: gaugeSec, start: 'top 72%', once: true}})
          .to(o, {v: 2.5, duration: 2.4, ease: 'power2.inOut', onUpdate: () => { num.textContent = o.v.toFixed(2); }}, 0)
          .to(ring, {strokeDashoffset: CIRC * (1 - TARGET), duration: 2.4, ease: 'power2.inOut'}, 0)
          .add(() => gaugeSec.querySelector('.jsl-gauge').classList.add('is-hold'))
          .to('.jsl-gauge', {scale: 1.04, duration: 0.14, yoyo: true, repeat: 1, ease: 'power2.out'})
          .add(() => setTimeout(() => gaugeSec.querySelector('.jsl-gauge').classList.remove('is-hold'), 600))
          .from('.jsl-preset', {y: 16, opacity: 0, duration: 0.5, stagger: 0.07, ease: 'expo.out'}, 0.4);
      }

      /* 5. steps: the line charges like a cable and lights each step */
      const line = root.querySelector('[data-steps-line]');
      if (line) g.to(line, {scaleY: 1, ease: 'none', scrollTrigger: {trigger: '[data-steps]', start: 'top 70%', end: 'bottom 60%', scrub: 0.4}});
      $$('[data-step]').forEach((li) => ST.create({trigger: li, start: 'top 68%', onEnter: () => li.classList.add('is-on'), onLeaveBack: () => li.classList.remove('is-on')}));

      /* 6. compare: the "with" column takes over */
      const cmp = root.querySelector('.jsl-compare');
      if (cmp) {
        g.timeline({scrollTrigger: {trigger: cmp, start: 'top 75%', once: true}})
          .from('[data-side="lose"]', {x: 30 * R, opacity: 0, duration: 0.7, ease: 'expo.out', clearProps: 'opacity,transform'})
          .from('[data-side="win"]', {x: -30 * R, opacity: 0, scale: 0.96, duration: 0.8, ease: 'expo.out', clearProps: 'opacity,transform'}, 0.15)
          .add(() => cmp.classList.add('is-won'), 0.7)
          .from('[data-side="win"] li', {x: -14 * R, opacity: 0, duration: 0.45, stagger: 0.07, ease: 'expo.out'}, 0.55);
      }

      /* 7. demos row: slight lift as a set */
      const demos = root.querySelector('[data-demos]');
      if (demos && desktop) g.from(demos.children, {y: 50, rotate: (i) => (i - 1) * -2, duration: 1, ease: 'expo.out', stagger: 0.1, scrollTrigger: {trigger: demos, start: 'top 85%', once: true}});

      /* 8. order block arrives with weight */
      if (order) g.from('.jsl-order', {y: 40, scale: 0.98, opacity: 0, duration: 1, ease: 'expo.out', scrollTrigger: {trigger: order, start: 'top 85%', once: true}});

      /* 9. magnetic CTAs (fine pointer only) */
      // created lazily on first hover so it never overwrites an entrance tween on the same element
      if (hover) $$('[data-magnetic]').forEach((b) => {
        let xTo, yTo;
        b.addEventListener('pointermove', (e) => {
          if (!xTo) { xTo = g.quickTo(b, 'x', {duration: 0.45, ease: 'power3'}); yTo = g.quickTo(b, 'y', {duration: 0.45, ease: 'power3'}); }
          const r = b.getBoundingClientRect(); xTo((e.clientX - r.left - r.width / 2) * 0.22); yTo((e.clientY - r.top - r.height / 2) * 0.3);
        });
        b.addEventListener('pointerleave', () => { if (xTo) { xTo(0); yTo(0); } });
      });
    });

    // late layout (fonts, images, app form) shifts trigger positions
    document.fonts && document.fonts.ready.then(() => ST.refresh());
    addEventListener('load', () => ST.refresh(), {once: true});
    if ('ResizeObserver' in window && order) new ResizeObserver(() => ST.refresh()).observe(order);
  };
  if (window.gsap) start(); else addEventListener('load', start, {once: true});
})();
